import { render, staticRenderFns } from "./businessResume.vue?vue&type=template&id=193c8105&scoped=true&"
import script from "./businessResume.vue?vue&type=script&lang=js&"
export * from "./businessResume.vue?vue&type=script&lang=js&"
import style0 from "./businessResume.vue?vue&type=style&index=0&id=193c8105&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193c8105",
  null
  
)

export default component.exports